import React, { useEffect, useState } from "react";
import voxAppicon from "../Assets/images/logo.png";
import "../Style/scss/pages/dashboard.scss";
import { emailValidation } from "../Common/Validations";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../Redux/Slice/Authentication/ForgotPasswordSlice";
import { ErrorModel } from "../Model/ErrorModel";
import { SuccessModel } from "../Model/SuccessModel";
import { Loader } from "../Common/Loader";

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [errorModal, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isFormDisabled = emailError !== "" || email === "";

  const handleChange = (e) => {
    let value = e.target.value;
    value = value.trimStart();
    value = value.trimEnd();
    const isValid = emailValidation(value);
    setEmail(value);
    if (isValid || value === "") {
      setEmailError("");
    } else {
      setEmailError("Please enter valid email");
    }
  };

  const handleSubmit = async () => {
    //TODO : handle submit API here
    const body = { email };
    setIsLoading(true);
    const result = await dispatch(forgotPassword(body));
    if (
      forgotPassword.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      // navigate("/qr-scanner", {state: {email:body.email, from:true}});
      setIsLoading(false);
      setSuccessMessage("Reset password link sent on your registered Email");
      setSuccessModel(true);
      setTimeout(() => {
        navigate("/");
        setSuccessModel(false);
      }, 2000);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
    // navigate("/resetpassword");
  };


  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        if (!isFormDisabled) {
          handleSubmit();
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [isFormDisabled]);


  return (
    <section className="layoutContainer layoutContainer--full">
      {errorModal ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      <div className="layoutGrid">
        <div className="page page--loginOtp">
          <div className="page__head">
            <div className="page__head__logo">
              <img src={voxAppicon} alt="Logo | Vox App" />
            </div>
          </div>
          <div className="page__body">
            <div className="emailVerificationCard">
              <div className="branding">
                <div className="branding__logo">
                  <svg
                    width="73"
                    height="57"
                    viewBox="0 0 73 57"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="2.8335"
                      y="3.25"
                      width="67.3333"
                      height="50.5"
                      rx="8.41667"
                      stroke="#0F172A"
                      stroke-width="5.05"
                    />
                    <path
                      d="M2.8335 15.875L32.7361 30.8263C35.1056 32.0111 37.8947 32.0111 40.2642 30.8263L70.1668 15.875"
                      stroke="#0F172A"
                      stroke-width="5.05"
                    />
                    <path
                      d="M33.8653 28.5679L8.27592 15.7732C6.48793 14.8792 5.3585 13.0517 5.3585 11.0527C5.3585 8.1379 7.72139 5.775 10.6362 5.775H62.3641C65.2789 5.775 67.6418 8.1379 67.6418 11.0527C67.6418 13.0517 66.5124 14.8792 64.7244 15.7732L39.135 28.5679C37.4763 29.3972 35.524 29.3972 33.8653 28.5679Z"
                      fill="#7E869E"
                      fill-opacity="0.25"
                      stroke="#222222"
                      stroke-width="5.05"
                    />
                  </svg>
                </div>
                <div className="branding__info textCenter">
                  <h1 className="title title--h1">Email Address</h1>
                  <p className="text">
                    Please provide your email for which you <br />
                    want to reset password
                  </p>
                </div>
              </div>
              <div className="emailVerificationCard__form">
                <div className="form__group">
                  <label for="email" className="form__label">
                    Email Address
                  </label>
                  <input
                    type="text"
                    id="email"
                    value={email}
                    autoComplete="off"
                    onChange={handleChange}
                    maxLength={100}
                    className="form__input"
                    placeholder="Enter your email address"
                  />
                  <div className="form__error">{emailError}</div>
                </div>
                <div className="form__button textCenter">
                  <button
                    disabled={isFormDisabled}
                    className="btn btn__primary btn--full"
                    onClick={handleSubmit}
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
